// extracted by mini-css-extract-plugin
export default {"editingCollaboration-outContent":"editingCollaboration-outContent--E61oe"};